export function exportPNG(canvas: HTMLCanvasElement, filename?: string): void {
  const link = document.createElement('a');
  link.download = filename || `hum-canvas-${Date.now()}.png`;
  link.href = canvas.toDataURL('image/png');
  link.click();
}
